import React from "react";
import { useRouteLoaderData } from "react-router";
import { ResultSet } from "../../../../../../API/fields";
import { CrumbProps } from "../../../../../../Component/Breadcrumbs/Breadcrumb";
import { ProductName } from "../../../../../../Component/Product/ProductName";

export default function ResultSetCrumb({
  match,
}: CrumbProps<"resultSetId">): React.ReactNode {
  const resultSets = useRouteLoaderData("field") as ResultSet[] | undefined;

  const resultSet = resultSets?.find(
    (resultSet) => resultSet.id === match.params.resultSetId,
  );

  return resultSet ? <ProductName sku={resultSet.product_sku} /> : null;
}
